import React, { useEffect, useState } from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';
import ProfileNavBar from './ProfileNavBar';
import Footer from './Footer';
import UserFooter from './UserFooter';
import ChatComponent from './ChatComponent';

const Dashboard = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    return (
        <div>
            <ProfileNavBar />
            <ChatComponent />
            <UserFooter />
            <Footer />
        </div>
    );
};

export default Dashboard;
